import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DEPOSIT_ROUTE,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  LOGIN_ROUTE,
  logout,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RootState,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
  useAppDispatch,
  useAppSelector,
  WITHDRAW_ROUTE,
  UserMenuEnum,
  getUsername,
  notDemoUser,
  getLangData,
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  showToast,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserIcon from "../../../assets/images/Casino_svg_img/User_Icon.svg";
import {
  defaultHeaderLogoClassName,
  headerGradient,
} from "../../../utils/constants/common.constants";
import { getEnvVariable } from "../../../constants/brandConfig";
import { domain, HOUSE_NAME } from "../../../constants/Branding";
import MenuComponent from "../shared/MenuComponent";
import NewsAndPromotions from "../shared/NewsAndPromotions";
import HeaderButtonComponent from "./HeaderButtonComponent";
import HeaderSearchInput from "./HeaderSearchInput";
import LoginButtons from "./LoginButtons";
import SubHeader from "./SubHeader";
import Modal from "../shared/ExpModal";
import OpenBets from "../open-bets/OpenBets";
import Button from "../shared/Button/Button";
import OpenBetsPopup from "../open-bets/OpenBetsPopup";
import { connect } from "react-redux";
import SkinOptions from "./SkinOptions";
import SkinIcon from "../../../assets/icons/header-icons/skins-icon.svg";
import IndigoSkinIcon from "../../../assets/icons/header-icons/skin.svg";
import { FaWhatsapp } from "react-icons/fa";
import whatsappIcon from "../../../assets/icons/whatsapp-icon-green.svg";
import Languages from "../user-menu-pages/Languages";
import LanguagesList from "../user-menu-pages/LanguagesList";
import { InfoTooltip } from "./InfoComponent";
import AllOpenBets from "../user-menu-pages/OpenBets/AllOpenBets";
import { getTawkSiteConfig } from "../../../tawkSites";
import DownloadApkButton from "../shared/DownloadApkButton";
interface HeaderProps {
  disableSportsSubheader?: boolean;
  balance: number;
  exposure: number;
  loggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({
  disableSportsSubheader,
  balance,
  exposure,
  loggedIn,
}) => {
  const [showOpenBets, setShowOpenBets] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const pathName = useLocation().pathname;
  const [Balance, setBalance] = useState<string | number>(balance);
  const [Exposure, setExposure] = useState<string | number>(exposure);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [langSelected, setLangSelected] = useState<string>();
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const hasInplayInPath = pathName.includes(IN_PLAY_ROUTE);

  const navigate = useNavigate();
  const { domainConfig } = useAppSelector((state) => state.common);
  const { balanceSummary } = useAppSelector((state) => state.auth);
  const bonus = balanceSummary?.bonus ?? 0;

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isSkinOpen, setIsSkinOpen] = useState(false);
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const userMenuList = [
    {
      title: UserMenuEnum.MY_PROFILE,
      navigationUrl: MY_PROFILE_ROUTE,
      enabled: notDemoUser(),
    },
    {
      title: "2FA auth",
      navigationUrl: `${MY_PROFILE_ROUTE}?tab=2FA`,
      enabled: notDemoUser(),
    },
    { title: UserMenuEnum.HOME, navigationUrl: HOME_ROUTE },
    {
      title: UserMenuEnum.ACCOUNT_STATEMENT,
      navigationUrl: ACCOUNT_STATEMENT_ROUTE,
      enabled: true,
    },
    {
      title: UserMenuEnum.PROFIT_LOSS_REPORT,
      navigationUrl: PROFIT_LOSS_REPORT_ROUTE,
      enabled: true,
    },
    // {
    //   title: UserMenuEnum.MY_WALLET,
    //   navigationUrl: MY_WALLET_ROUTE,
    //   enabled: true,
    // },
    // {
    //   title: UserMenuEnum.TURNOVER_REPORT,
    //   navigationUrl: TURNOVER_REPORT_ROUTE,
    //   enabled: true,
    // },
    {
      title: UserMenuEnum.AFFILIATE_PROGRAM,
      navigationUrl: AFFILIATE_PROGRAM_ROUTE,
      enabled: domainConfig.affiliate && notDemoUser(),
    },
    {
      title: UserMenuEnum.TURNOVER_REPORT,
      navigationUrl: TURNOVER_REPORT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    {
      title: UserMenuEnum.BONUS_STATEMENT,
      navigationUrl: BONUS_STATEMENT_ROUTE,
      enabled: domainConfig.bonus && notDemoUser(),
    },
    // {
    //   title: "deposit_turnover", //add to ui core
    //   navigationUrl: "/deposit-turnover", //add route to ui core
    //   enabled: true,
    // },
    {
      title: "promotions", //add to ui core
      navigationUrl: "/promotions", //add route to ui core
      enabled: true,
    },
    {
      title: UserMenuEnum.MY_TRANSACTION,
      navigationUrl: MY_TRANSACTION_ROUTE,
      enabled: domainConfig.payments && notDemoUser(),
    },
    // {
    //   title: UserMenuEnum.STAKE_SETTINGS,
    //   navigationUrl: STAKE_SETTINGS_ROUTE,
    //   enabled: true,
    // },

    {
      title: UserMenuEnum.MY_BET,
      navigationUrl: MY_BETS_ROUTE,
      enabled: true,
    },
    {
      title: "Language",
      enabled: true,
      langKey: "language",
      openLanguageList: true,
    },
    {
      title: "Change Password",
      navigationUrl: "/change-password",
      enabled: notDemoUser(),
    },
    {
      title: UserMenuEnum.SIGNOUT,
      navigationUrl: LOGIN_ROUTE,
      enabled: true,
    },
  ];
  const { langData } = useAppSelector((state) => state.cms);

  useEffect(() => {
    const selectedLang = sessionStorage.getItem("lang")
      ? sessionStorage.getItem("lang")
      : "en";
    dispatch(getLangData(selectedLang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const skins = getEnvVariable(domain, "skins");
  const hasSkins = skins && skins.length > 0;

  const ToggleSkins = () => {
    return (
      <MenuComponent
        menuTitle={<img src={HOUSE_NAME === 'indigo' ? IndigoSkinIcon : SkinIcon} className={HOUSE_NAME === 'indigo' ? "min-w-6 min-h-6 w-6 h-6" : "min-w-7 min-h-7 w-7 h-7"}/>}
        menuList={<SkinOptions />}
        dropdownClassName="mt-0.5"
        isOpen={isSkinOpen}
        closeMenu={() => setIsSkinOpen(false)}
        toggleMenu={() => setIsSkinOpen(!isSkinOpen)}
      />
    );
  };

  const menuList = (
    <ul className="flex flex-col font-helvetica text-[11px]">
      <li className="p-2 text-white text-xs font-bold bg-custom-four-color-gradient">
        {getUsername()}
      </li>
      {userMenuList.map(
        ({ title, navigationUrl, enabled, langKey, openLanguageList }, index) => {
          const isTwoFactorAuth =
            langKey === "two_factor_auth" ||
            title === "2FA" ||
            title === "2FA auth";

          return (
          enabled &&
          title !== UserMenuEnum.SIGNOUT && (
            <li
              key={index}
              className="hover:underline cursor-pointer border-b border-b-gray18"
            >
              {openLanguageList ? (
                <div>
                  <div
                    className="px-2 py-1"
                    onClick={() => setIsLanguageOpen((open) => !open)}
                  >
                    {langKey ? langData?.[langKey] ?? title : title}
                  </div>
                  {isLanguageOpen && (
                    <LanguagesList
                      langSelected={langSelected}
                      setLangSelected={setLangSelected}
                      onClose={() => setIsLanguageOpen(false)}
                    />
                  )}
                </div>
              ) : (
                <div className="px-2 py-1">
                  <Link to={navigationUrl || ""} className="cursor-pointer">
                    <span className={isTwoFactorAuth ? "two-factor-auth-text-blink" : ""}>
                      {langKey ? langData?.[langKey] ?? title : title}
                    </span>
                  </Link>
                </div>
              )}
            </li>
          )
          );
        }
      )}
      <li>
        <DownloadApkButton onDownload={closeMenu} />
      </li>
      <li>
        <div
          className="text-center bg-blue4 text-white py-2 font-bold text-xs cursor-pointer"
          onClick={() => {
            closeMenu();
            dispatch(logout());
            dispatch(
              showToast({
                type: "success",
                message: "Logged out successfully",
              })
            );
          }}
        >
          {langData?.["logout"]}
        </div>
      </li>
    </ul>
  );

  const handleWithdrawClick = () => {
    navigate(WITHDRAW_ROUTE);
  };

  const handleDepositClick = () => {
    navigate(DEPOSIT_ROUTE);
  };

  const registrationWhatsappLink =
    ((domainConfig as any)?.supportContacts || (domainConfig as any)?.suppportContacts)?.find(
      (contact) => contact?.contactType === "REGISTRATION_WHATSAPP_LINK"
    )?.details;
  const whatsappRedirectUrl = registrationWhatsappLink
    ? registrationWhatsappLink.startsWith("http://") ||
      registrationWhatsappLink.startsWith("https://") ||
      registrationWhatsappLink.startsWith("//")
      ? registrationWhatsappLink
      : `//${registrationWhatsappLink}`
    : "";

  const isTawkIntegrated = Boolean(
    getTawkSiteConfig(window.location.hostname)
  );
  const isWhatsappSupportEnabled =
    !isTawkIntegrated &&
    (Boolean((domainConfig as any)?.whatsappSupport) ||
      Boolean((domainConfig as any)?.whatsapp) ||
      Boolean((domainConfig as any)?.whatsapp_support));

  // useEffect(() => {
  //   // console.log('langsel1--->>>')
  //   if(langSelected !== undefined){
  //     // console.log('langsel2--->>>')
  //       sessionStorage.setItem("lang", langSelected);
  //       dispatch(getLangData(langSelected));
  //   }
  // }, [langSelected]);

  return (
    <div
      className={`flex flex-col flex-0 md:gap-[1px] w-full ${
        isMobile && !hasInplayInPath ? "gap-[1px]" : ""
      }`}
    >
      <div
        className={`flex items-center justify-between p-1.5 md:p-2 ${headerGradient}`}
      >
        <div className="flex md:gap-3 items-center">
          <img
            src={sessionStorage.getItem("brandLogo") || getEnvVariable(domain, 'logo')}
            alt="logo"
            // className={getEnvVariable(domain, 'logoClassName') ?? defaultHeaderLogoClassName}
            className={getEnvVariable(domain, 'logoClassName') ?? "h-[var(--titleMobHeight)] w-[var(--titleMobWidth)] md:h-[var(--titleHeight)] md:w-[var(--titleWidth)] md:my-2 lg:my-0 cursor-pointer"}
            onClick={() => navigate(`${HOME_ROUTE}`)}
          />

          {loggedIn && (
            <div className="hidden md:block">
              <HeaderSearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />
            </div>
          )}
        </div>

        {loggedIn ? (
          <div className="flex gap-2 md:gap-1 items-center">
            {isWhatsappSupportEnabled && whatsappRedirectUrl && !isMobile && (
              <a
                href={whatsappRedirectUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-[30px] w-[30px] rounded-full bg-[#25D366] text-white"
                aria-label="WhatsApp Support"
              >
                <FaWhatsapp size={18} />
              </a>
            )}
            {domainConfig?.payments && domainConfig.b2cEnabled && !isMobile && (
              <div className="flex justify-center">
                {getUsername() !== "Demo User" && (
                  <>
                    <Button
                      onClick={handleDepositClick}
                      className="flex gap-2 text-xs rounded items-center bg-[#008000] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {langData?.["deposit"] ?? "Deposit"}
                      </span>
                    </Button>

                    <Button
                      onClick={handleWithdrawClick}
                      className="flex gap-2 text-xs rounded items-center bg-[#FF0000] py-[2px] w-fit px-1 md:px-2 md:py-[5px] justify-center mx-1 border border-white"
                    >
                      <span className=" my-auto text-white">
                        {langData?.["withdraw"] ?? "Withdraw"}
                      </span>
                    </Button>
                  </>
                )}
              </div>
            )}
            <div className="flex items-center md:gap-1">
              <div className="flex items-center flex-row-reverse md:gap-1 md:flex-row">
                <HeaderButtonComponent
                  onClick={() => {}}
                  isRedButton={false}
                  customButtonHeight="h-[30px]"
                  customButtonRadius="rounded-[5px] md:rounded-[5px]"
                  customCSS={isDesktop ? "" : "!p-[2px_6px]"}
                >
                  {isDesktop ? (
                    <div className="flex flex-col md:flex-row gap-0 md:gap-1 items-center text-[11px] text-white font-bold">
                      <div className="flex gap-1 hover:underline">
                        <span className="font-thin text-gray-400 ">Bal </span>
                        {((Number(balance)/cFactor) - Number(exposure)/cFactor)?.toFixed(2)}
                        <InfoTooltip />
                      </div>
                      <div
                        className="flex gap-1 hover:underline"
                        onClick={() => setShowOpenBets(true)}
                      >
                        <span className="font-thin text-gray-400">Exp</span>
                        {(Number(exposure)/cFactor)?.toFixed(2)}
                      </div>
                      <div
                        className="flex gap-1 hover:underline"
                      >
                        <span className="font-thin text-gray-400">Bonus</span>
                        {Number(bonus)?.toFixed(2)}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-1.5 text-[9px] leading-none text-white">
                      <div className="min-w-0 max-w-[88px]">
                        <p className="truncate font-semibold uppercase">
                          {getUsername()}
                        </p>
                        <p className="mt-px text-gray-400">
                          Bonus{" "}
                          <span className="text-white">
                            {Number(bonus)?.toFixed(2)}
                          </span>
                        </p>
                      </div>
                      <span className="h-[2.2rem] border-r-[px] border-blue-500 "></span>
                      {/* Balance */}      
                      <span className="h-6 w-px shrink-0 bg-white/25" />
                      <div className="shrink-0 space-y-px">
                        <p className="flex items-center gap-0.5">
                          <span className="text-gray-400">Bal </span>
                          <span className="font-semibold">
                            {((Number(balance)/cFactor) - Number(exposure)/cFactor)?.toFixed(2)}
                          </span>
                          <InfoTooltip />
                        </p>
                        <p
                          className="cursor-pointer text-left"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowOpenBets(true);
                          }}
                        >
                          <span className="text-gray-400">Exp </span>
                          <span className="font-semibold">
                            {Number(exposure)?.toFixed(2)}
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </HeaderButtonComponent>
                <div className="relative hidden md:flex items-center gap-1">
                  <MenuComponent
                    menuList={menuList}
                    menuTitle={getUsername()}
                    customImage={{ imagePosition: "left", imageSrc: UserIcon }}
                    customButtonCss="bg-blue4 text-white text-xs rounded-[5px] h-[30px] px-3"
                    toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                    isOpen={isMenuOpen}
                    closeMenu={closeMenu}
                  />
                  <Languages
                    langSelected={langSelected}
                    setLangSelected={setLangSelected}
                  />
                </div>
                {/* <HeaderButtonComponent
                  onClick={() => {}}
                  leftIcon={{
                    src: UserIcon,
                    alt: "Icon Description",
                    customClassName: "h-3 w-3",
                  }}
                  ButtonText={getUsername()}
                  isRedButton={false}
                  customCSS="border-r border-blue33"
                  customButtonHeight="h-[38px] md:h-[30px]"
                  customButtonRadius="rounded-l-[5px] md:rounded-[5px]"
                /> */}
              </div>

              {hasSkins &&
                HOUSE_NAME !== "cricket100" &&
                HOUSE_NAME !== "crik18" &&
                HOUSE_NAME !== "one8" &&
                ToggleSkins()}
            </div>
          </div>
        ) : (
          <div className="flex gap-1 items-center">
            {isWhatsappSupportEnabled && whatsappRedirectUrl && !isMobile && (
              <a
                href={whatsappRedirectUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center h-[30px] w-[30px] rounded-full bg-[#25D366] text-white"
                aria-label="WhatsApp Support"
              >
                <FaWhatsapp size={18} />
              </a>
            )}
            <LoginButtons />
          </div>
        )}
      </div>

      {pathName === `${HOME_ROUTE}` && isMobile && (
        <div className="md:hidden">
          <NewsAndPromotions />
        </div>
      )}

      <div className="w-screen bg-black">
        <SubHeader disableSportsSubheader={disableSportsSubheader} />
      </div>
      <Modal
        isOpen={showOpenBets}
        onClose={() => {
          setShowOpenBets(false);
        }}
        title={langData?.["my_market"]}
        modalBg="bg-custom-four-color-gradient"
      >
        <AllOpenBets setShowOpenBets={setShowOpenBets} />
      </Modal>

      {isWhatsappSupportEnabled && whatsappRedirectUrl && (
        <a
          href={whatsappRedirectUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="md:hidden fixed bottom-[54px] left-2 z-30 flex items-center justify-center h-10 w-10 shadow-lg"
          aria-label="WhatsApp Support"
        >
          <img
            src={whatsappIcon}
            alt=""
            className="h-10 w-10 object-contain"
            aria-hidden
          />
        </a>
      )}
    </div>
  );
};
export default Header;
